import PrimaryButton from "components/buttons/primary-button";
import Typography from "components/typography";
import React from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";

interface IProps {
  reviewText: string;
  name: string;
  avatar: string;
  occupation: string;
  nationality: string;
  next: () => void;
  prev: () => void;
  reviewsLength: number;
  currentReviewIndex: number;
}
const Review = ({
  name,
  reviewText,
  occupation,
  nationality,
  avatar,
  next,
  prev,
  reviewsLength,
  currentReviewIndex
}: IProps) => {
  return (
    <Container>
      <Avatar src={avatar} alt={`${name}'s avatar`} />
      <Body>
        <BodyHeader>
          <div>
            <Typography
              size="6.4rem"
              weight="medium"
              mb="1.2"
              lh="5"
              m_size="4xl"
              m_mb="0.4"
              m_lh="3"
            >
              {name}
            </Typography>
            <Typography
              color={Colors.yellow400}
              size="lg"
              weight="medium"
              mb="0.8"
              m_size="s"
              m_mb="0.2"
            >
              {occupation}
            </Typography>
            <Typography color={Colors.grey500} m_size="xs">
              {nationality}
            </Typography>
          </div>
          <Typography size="16.4rem" lh="10" m_display="none">
            ”
          </Typography>
        </BodyHeader>
        <CommentArea>
          <Typography
            size="3.2rem"
            mb="2.4rem"
            m_size="xl"
            color={Colors.grey300}
          >
            {reviewText}
          </Typography>
        </CommentArea>
        <Buttons>
          <PrimaryButton
            rounded
            disabled={currentReviewIndex === 0}
            onClick={prev}
            icon={
              <IconContainer>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="100%"
                  height="100%"
                  viewBox="0 0 24 25"
                  fill="none"
                >
                  <path
                    d="M19 12.5H5"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M12 19.5L5 12.5L12 5.5"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </IconContainer>
            }
            iconPosition="center"
            fitContent
          />
          <PrimaryButton
            rounded
            disabled={currentReviewIndex === reviewsLength - 1}
            onClick={next}
            icon={
              <IconContainer>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="100%"
                  height="100%"
                  viewBox="0 0 24 25"
                  fill="none"
                >
                  <path
                    d="M5 12.5H19"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M12 19.5L19 12.5L12 5.5"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </IconContainer>
            }
            iconPosition="center"
            fitContent
          />
        </Buttons>
      </Body>
    </Container>
  );
};

export default Review;

const Container = styled.div`
  display: flex;
  width: 100%;
  height: 42rem;
  @media only screen and (max-width: 769px) {
    height: fit-content;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
`;
const Avatar = styled.img`
  width: 42rem;
  height: 42rem;
  border-radius: 50%;
  background-color: gray;
  object-fit: cover;
  margin-right: 5rem;
  @media only screen and (max-width: 769px) {
    width: 15rem;
    height: 15rem;
    margin-bottom: 2rem;
    margin-right: 0;
  }
`;

const Body = styled.div`
  width: 70%;
  display: flex;
  flex-direction: column;
  @media only screen and (max-width: 769px) {
    width: 100%;
    align-items: center;
    text-align: center;
  }
`;

const BodyHeader = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: start;
  @media only screen and (max-width: 769px) {
    justify-content: center;
  }
`;

const CommentArea = styled.div`
  width: 80%;
  @media only screen and (max-width: 769px) {
    width: 100%;
  }
`;

const Buttons = styled.div`
  display: flex;
  align-items: center;
  gap: 3.2rem;
  margin-top: auto;
  margin-bottom: 6.4rem;
  @media only screen and (max-width: 769px) {
    margin-top: 2rem;
    width: 100%;
    justify-content: space-between;
  }
`;

const IconContainer = styled.div`
  width: 2.4rem;
  height: 3rem;
  @media only screen and (max-width: 769px) {
    height: 2.4rem;
  }
`;
